module.exports = __webpack_public_path__ + "io.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/io.svg
// module id = 613
// module chunks = 0